import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory as createHistory } from 'history';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import getEnvironment from '~/lib/environment';

import App from './App';
import Loading from '~/pages/Loading';
import * as serviceWorker from './serviceWorker';

import { offerMap } from '~/utils';
import { fetchCardDetails, fetchMaintenanceWindow } from '~/apis';
import { disableMobileXExitPrompt, enableMobileXExitPrompt } from '~/lib/mobile-x';

const history = createHistory();

enableMobileXExitPrompt();
history.listen((location) => {
  const enableExitPromptForPage = {
    '/success': false,
    '/': true,
    '/error': false,
  };
  if (enableExitPromptForPage[get(location, 'pathname')]) {
    enableMobileXExitPrompt();
  } else {
    disableMobileXExitPrompt();
  }
});

const environment = getEnvironment();

const initTealium = () => {
  const account = environment.tealium.account;
  const profile = environment.tealium.profile;
  const env = environment.tealium.environment;

  window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
  window.utag_cfg_ovrd.noview = true;

  const script1 = document.createElement('script');
  script1.id = 'utag-sync-script';
  script1.src = `https://tags.tiqcdn.com/utag/${account}/${profile}/${env}/utag.sync.js`;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.id = 'utag-script';
  script2.src = `https://tags.tiqcdn.com/utag/${account}/${profile}/${env}/utag.js`;
  document.head.appendChild(script2);
};

const initialData = async () => {
  let globalData = {
    ismobile: global.IS_MOBILE,
    locale: environment.forceLocale === 'YES'? 'es' : global.LOCALE,
    offerId: global.OFFER_ID,
  };
  try {
    if (isEmpty(offerMap(globalData.offerId))) {
      throw new Error('Invalid offer type');
    }
    if (environment.tealium.isEnabled) {
      initTealium();
    }
    ReactDOM.render(
      <Loading show />,
      document.getElementById('root')
    );
    globalData = {
      ...globalData,
    };
    let data, maintenanceWindowResponse;
    if (environment.maintenanceWindow.isEnabled) {
      maintenanceWindowResponse = await fetchMaintenanceWindow(`${global.window.location.protocol}//${environment.maintenanceWindow.url}`);
      if (!get(maintenanceWindowResponse, 'underMaintenance')) {
        data = await fetchCardDetails({ globalData });
      } else {
        throw new Error('Under maintenance window period');
      }
    } else {
      data = await fetchCardDetails({ globalData });
    }
    ReactDOM.render(<App cardOfferData={data} globalData={globalData} history={history} />, document.getElementById('root'));
  } catch (err) {
    if (environment.tealium.isEnabled) {
      initTealium();
    }
    history.push('/error' + history.location.search);
    ReactDOM.render(<App globalData={globalData} history={history} />, document.getElementById('root'));
  }
};

initialData();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
